import { PaginationModel, Price, SortModel } from '@spartacus/core';

export interface CustomOrderHistoryOverview {
  orders?: CustomOrderHistory[];
  pagination?: PaginationModel;
  sorts?: SortModel[];
}

export interface CustomOrderHistory {
  code?: number;
  cancelable?: boolean;
  updateable?: boolean;
  deliveryAddress?: CustomOrderHistoryAddress;
  state?: CustomOrderHistoryState;
  orderDate?: Date;
  formattedOrderDate?: string;
  deliverKW: Date;
  formattedDeliverKW: string;
  valutaDate: Date;
  formattedValutaDate: string;
  customerReference: string;
  textReLs: string;
  totalPrice: number;
  shippingCosts: number;
  shippingCostsData: Price;
  totalPriceData: Price;
  entries: CustomOrderHistoryEntry[];
}

export interface CustomOrderHistoryEntry {
  position?: number;
  orderState?: CustomOrderHistoryState;
  productCode?: number;
  description?: string;
  orderedQuantity?: number;
  deliveredQuantity?: number;
  totalPrice?: number;
  totalPriceData?: Price;
  deliverKW?: Date;
  formattedDeliverKW?: number;
  cancelable?: boolean;
  code?: string;
  olfQuantity?: number;
  vsQuantity?: number;
  unitCode?: string;
  netPrice?: number;
  netPriceData?: Price;
  currencyCode?: string;
  salesOrganization?: string;
  noChange?: boolean;
}

export interface CustomOrderHistoryAddress {
  name1?: string;
  name2?: string;
  name3?: string;
  name4?: string;
  street?: string;
  houseNumber?: string;
  city?: string;
  postalCode?: string;
}

export interface CustomOrderHistoryRequest {
  type: string;
  orderId?: string;
  productCode?: string;
  orderDateFrom?: string;
  orderDateTo?: string;
}

export interface CustomOrderHistoryUpdate {
  orderNumber: string;
  updatePosition: number;
  entries: CustomOrderHistoryUpdateEntry[];
}

export interface CustomOrderHistoryUpdateEntry {
  position: number;
  quantity: number;
}

export enum CustomOrderHistoryState {
  COMPLETED,
  RESERVED,
  SHIPPING,
  WITH_OPEN_POSITIONS
}

export enum CustomOrderHistoryFilter {
  OVERVIEW,
  OPEN,
  REMAINS
}

export enum CustomOrderHistoryDefaultSortOptions {
  code,
  state,
  orderDate,
  deliverKW,
  valutaDate,
  shippingCosts,
  totalPrice
}

export enum CustomOrderHistoryRemainsSortOptions {
  code,
  position,
  orderState,
  productCode,
  description,
  orderedQuantity,
  deliveredQuantity,
  netPrice
}

export enum CustomOrderHistoryDetailSortOptions {
  position,
  orderState,
  productCode,
  orderedQuantity,
  deliveredQuantity,
  totalPrice,
  formattedDeliverKW
}

export interface CustomOrderHistoryFilterAndSortData {
  type: string;
  orderId?: string;
  productCode?: string;
  orderDateFrom?: string;
  orderDateTo?: string;
  sortOption?: string;
  sortDirection?: string;
}